// -----------------------------------------------------------------------
// <copyright company="Microsoft Corporation">
// Copyright (c) Microsoft Corporation. All rights reserved.
// </copyright>
// -----------------------------------------------------------------------

/**
 * Represent an Observer registered to a given Observable object.
 */
export class Observer<T> {
  /**
   * This observer is flagged to be removed and will not be executed anymore.
   */
  public willBeUnregistered = false;
  /**
   * Gets or sets a property defining that the observer as to be unregistered after the next notification.
   */
  public unregisterOnNextCall = false;

  /**
   * Defines the callback to call when the observer is notified.
   */
  public readonly callback: (newValue: T) => void;

  /**
   * Creates a new observer.
   *
   * @param callback - Defines the callback to call when the observer is notified.
   */
  public constructor(callback: (newValue: T) => void) {
    this.callback = callback;
  }
}
